import styles from './YandexProjectLogo.module.css';

export default function YandexProjectLogo() {
    return <div className={styles.container}>
        <span className={styles.text}>Проект компании</span>
        <a href="https://yandex.ru" target="_blank" className={styles.logo}></a>
    </div>
}